"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformChildSeatToYearString = transformChildSeatToYearString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformChildSeatToYearString(childSeatType) {
    switch (childSeatType) {
        case legacy_enums_1.ChildSeatType.Booster:
            return "6-11 years";
        case legacy_enums_1.ChildSeatType.BoosterSeat:
            return "4-6 years";
        case legacy_enums_1.ChildSeatType.ForwardFacing:
            return "1-4 years";
        case legacy_enums_1.ChildSeatType.RearFacing:
            return "0-1 year";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformChildSeatToYearString.js.map